export default {
  profile: {
    title: "Профиль",
    subtitle: "Личные данные, портфолио и профессиональная информация.",
    downloadPdf: "Скачать PDF",
    downloadPdfGenerating: "Формируем PDF…",
    downloadPdfError: "Не удалось скачать PDF профиля",
    tabs: {
      personal: "Мои данные",
      creativeSelfDefinition: "Самоопределение",
      education: "Образование",
      languages: "Языки",
      work: "Работа",
      portfolio: "Портфолио",
      accounts: "Аккаунты",
      memberships: "Союзы",
    },
    avatar: {
      title: "Аватар",
      imageLabel: "Изображение",
      alt: "Аватар",
    },
    general: {
      title: "Общие данные",
      lastName: "Фамилия",
      firstName: "Имя",
      middleName: "Отчество",
      middlePlaceholder: "Ваше отчество",
      birthDate: "Дата рождения",
      phone: "Телефон",
      email: "E-mail",
      gender: "Пол",
      male: "Мужской",
      female: "Женский",
      about: "О себе",
    },
    password: {
      sectionTitle: "Смена пароля",
      sectionLead: "Безопасность аккаунта",
      change: "Изменить пароль",
      current: "Текущий пароль",
      new: "Новый пароль",
      repeat: "Повторите пароль",
      resetHint: "Введите текущий пароль и новый (не менее 8 символов).",
      changeSubmit: "Сохранить новый пароль",
      changeSubmitting: "Сохранение…",
      changeSuccess: "Пароль успешно изменён",
      changeEmpty: "Заполните все поля",
      changeMustDifferFromCurrent: "Новый пароль должен отличаться от текущего",
      changeMismatch: "Новый пароль и повтор не совпадают",
      changeTooShort: "Новый пароль — не менее 8 символов",
      changeFail: "Не удалось сменить пароль",
    },
    creativeSelfDefinition: {
      introTitle: "Творческое самоопределение",
      introLead:
        "Выберите направление, поднаправление и роль, которая лучше всего описывает вашу творческую практику.",
      directionLabel: "Направление",
      subDirectionLabel: "Поднаправление",
      catalogRoleLabel: "Роль",
      catalogRoleHint:
        "Начните со списка: так профиль сразу свяжется с подходящими рекомендациями, мероприятиями и сервисами.",
      editSuggestedRole: "Изменить свою формулировку",
      customToggle: "Не нашёл свою роль",
      customRoleTitle: "Предложить свою роль",
      customRoleLabel: "Как назвать вашу роль",
      proposedDescriptionLabel: "Описание роли (необязательно)",
      proposedDescriptionPlaceholder:
        "Кратко опишите, чем вы занимаетесь в этой роли — модераторы увидят текст при рассмотрении предложения.",
      proposedDescriptionHint: "Не более {{max}} символов.",
      customPlaceholder: "Например: автор документальных подкастов",
      customHint:
        "Если подходящей роли нет в списке, напишите свою формулировку. Мы сохраним её в профиле и отправим модераторам, чтобы они рассмотрели добавление роли в общий список.",
      customCancel: "Отмена",
      customSaveSubmit: "Сохранить и отправить на проверку",
      customSaving: "Сохраняем и отправляем…",
      blockDescription: "Описание роли",
      blockRecommendations: "Что может быть полезно на платформе",
      blockWhoFits: "Кому может подойти",
      noCopyFallback: "Для этой формулировки пока нет расширенного описания.",
      roleValidation: "Выберите роль из списка или предложите свою формулировку.",
      suggestionSent: "Роль сохранена в профиле и отправлена модераторам на проверку.",
      suggestionError: "Не удалось отправить роль на проверку",
      customNeedSub: "Сначала выберите поднаправление — так мы поймём, к какой области относится новая роль.",
      customRoleDuplicateCatalog:
        "Такое название уже есть в списке ролей для выбранного поднаправления. Выберите его в списке — отправлять предложение не нужно.",
      catalogNeedExplicitSub:
        "Эта типовая роль привязана к нескольким поднаправлениям — выберите поднаправление перед сохранением.",
      loadError: "Не удалось загрузить данные самоопределения",
      saveError: "Не удалось сохранить самоопределение",
      formActionsAria: "Отменить правки или сохранить самоопределение",
    },
    loadError: "Не удалось загрузить профиль",
    saveError: "Не удалось сохранить",
    uploadError: "Не удалось загрузить файл",
    saving: "Сохранение…",
    emailReadOnlyHint: "E-mail меняется через поддержку или при регистрации",
    confirmDelete: {
      title: "Удалить запись?",
      message: "Запись будет удалена безвозвратно. Это действие нельзя отменить.",
      confirm: "Удалить",
    },
    achievementType: {
      1: "Грамота / диплом",
      2: "Сертификат",
      3: "Благодарственное письмо",
      4: "Патент",
      5: "Премия / награда",
      6: "Медаль / знак отличия",
      7: "Участие в конкурсе",
      8: "Иное",
    },
    tabsData: {
      loadFailed: "Ошибка загрузки данных",
      saveFailed: "Ошибка сохранения",
      deleteFailed: "Ошибка удаления",
      edit: "Изменить",
      delete: "Удалить",
      cancel: "Отмена",
      pick: "Выберите…",
      optional: "Не выбрано",
      now: "настоящее время",
      level: "Уровень образования",
      institution: "Учебное заведение",
      speciality: "Специальность",
      institutionFromList: "Выберите учебное заведение из списка подсказок",
      specialityFromList: "Выберите специальность из списка подсказок",
      startYear: "Год начала",
      endYear: "Год окончания",
      currentStudy: "Учусь сейчас",
      addEducation: "Новая запись об образовании",
      editEducation: "Редактирование образования",
      company: "Компания / организация",
      position: "Должность",
      yearsExperience: "Стаж (лет)",
      yearsShort: "{{n}} лет",
      industry: "Сфера деятельности",
      specialization: "Специализация",
      addWork: "Новое место работы",
      editWork: "Редактирование опыта",
      achievementName: "Название",
      achievementType: "Тип",
      customType: "Уточните тип",
      url: "Ссылка",
      eventDate: "Дата",
      image: "Вложение",
      uploadFile: "Загрузить файл",
      attachmentMaxSizeWarning: "Максимальный размер файла — 10 МБ.",
      attachmentFileTooLarge: "Файл больше 10 МБ. Выберите файл меньшего размера.",
      attachmentDropZoneTitle: "Нажмите, чтобы выбрать файл",
      attachmentDropZoneSubtitle:
        "Принимаются PDF; изображения JPEG, PNG и JFIF; видео MP4, MOV, AVI, MKV и WebM; аудио MP3, WAV, OGG, FLAC, AAC, M4A, M4B, M4P и M4V.",
      attachmentUploading: "Загружаем файл…",
      attachmentReplace: "Заменить файл",
      attachmentClear: "Удалить файл",
      addPortfolio: "Новое достижение",
      editPortfolio: "Редактирование достижения",
      addAccount: "Новый аккаунт",
      editAccount: "Редактирование ссылки",
      language: "Язык",
      languageLevel: "Уровень владения",
      addLanguage: "Добавить язык",
      editLanguage: "Редактирование языка",
      languagePickBoth: "Выберите язык и уровень владения",
      languageUnknown: "Язык",
      levelUnknown: "Уровень",
    },
    save: "Сохранить изменения",
    saved: "Сохранено",
    personalFormActionsAria: "Отменить правки или сохранить личные данные",
    addEducation: "Добавить место учёбы",
    addLanguage: "Добавить язык",
    addWork: "Добавить место работы",
    addPortfolio: "Добавить достижение",
    addAccount: "Добавить аккаунт",
    memberships: {
      tabTitle: "Союзы",
      tabSubtitle: "Добавляйте союзы, ассоциации и сообщества, в которых вы состоите.",
      add: "Добавить союз",
      addFirst: "Добавить первый союз",
      emptyTitle: "Союзов пока нет",
      emptyLead: "Добавьте союз, ассоциацию или сообщество — они появятся в вашей анкете.",
      statusApproved: "Заявка одобрена",
      statusPending: "Ожидает подтверждения",
      statusNotConfirmed: "Не подтверждён",
      statusRejected: "Отклонена",
      statusWithdrawn: "Снято",
      rejectionReasonLabel: "Причина отклонения",
      approvedBy: "Одобрил: {{name}}",
      approvedOn: "{{date}}",
      requiresApproval: "Нужна проверка",
      autoAccept: "Вступление сразу",
      loadError: "Не удалось загрузить союзы",
      createdToastApproved: "Союз добавлен",
      createdToastPending: "Заявка отправлена и ждёт подтверждения",
      updatedToast: "Союз обновлён",
      deleteTitle: "Удалить союз?",
      deleteMessage: "Союз «{{path}}» будет удалён из анкеты. Это действие нельзя отменить.",
      deleteError: "Не удалось удалить союз",
      resetApprovalNotice:
        "Для этого союза нужна проверка. После сохранения заявка снова перейдёт в ожидание подтверждения.",
      wizard: {
        title: "Добавить союз",
        editTitle: "Изменить союз",
        back: "Назад",
        next: "Далее",
        finish: "Готово",
        step1: "Тип союза",
        step2: "Индустрия",
        step3: "Выбор союза",
        step4: "Подтверждение",
        searchUnionLabel: "Найти союз",
        searchUnionPlaceholder: "Введите название союза или отделения…",
        searchNoResults: "Ничего не найдено",
        searchTreeLoading: "Ищем подходящие варианты…",
        pickKind: "Выберите тип союза",
        pickIndustry: "Выберите индустрию",
        pickInTree: "Выберите нужный союз или отделение",
        stopHere: "Выбрать этот союз",
        stopHereHint: "Заявка будет подана на выбранный союз.",
        selectedNode: "Вы выбрали",
        confirmTitle: "Проверьте данные",
        confirmKind: "Тип союза",
        confirmGroup: "Союз",
        loadError: "Не удалось загрузить данные шага",
        createError: "Не удалось подать заявку",
        updateError: "Не удалось обновить союз",
        emptyIndustries: "Для этого типа пока нет доступных союзов",
        membershipNotAllowed:
          "В этот союз нельзя вступить напрямую. Выберите другое отделение.",
        stopHereDisabledHint:
          "Подать заявку в этот союз напрямую нельзя. Выберите отделение ниже.",
      },
    },
    linked: "Подключён",
    notLinked: "Не подключён",
    since: "с {{year}}",
    portal: {
      pageTitle: "Личный кабинет",
      pageSubtitle: "Портал Российской государственной библиотеки: сервисы и анкета участника.",
      sidebarAria: "Профиль пользователя",
      navAria: "Разделы личного кабинета",
      overviewNav: "Обзор",
      backToSite: "На главную сайта",
      logout: "Выйти",
      welcome: "Здравствуйте, {{name}}!",
      welcomeHint:
        "Здесь вы управляете анкетой, подключаете аккаунты и переходите к мероприятиям и сервисам библиотеки.",
      completionLabel: "Заполнено: {{percent}}%",
      fillProfile: "Заполнить профиль",
      profileComplete: "Профиль полностью заполнен",
      completionProgressAria: "Заполнение профиля",
      servicesTitle: "Сервисы портала",
      services: {
        events: {
          title: "Мероприятия",
          desc: "Афиша, регистрация и материалы событий библиотеки.",
        },
        projects: {
          title: "Проекты",
          desc: "Инициативы, коллаборации и портфолио участников.",
        },
        deposit: {
          title: "Депонирование",
          desc: "Подача произведений и сопровождение депозита.",
        },
        admin: {
          title: "Администрирование",
          desc: "Роли и пользователи — только при соответствующих правах в системе.",
        },
      },
      anketaTitle: "Анкета участника",
      anketaHint: "Расскажите о себе: это поможет подбирать мероприятия и проекты.",
      completionMissingTitle: "Что ещё заполнить",
      completionMissingGoAria: "Перейти к заполнению: {{label}}",
      languageSwitch: {
        title: "Язык интерфейса",
        groupAria: "Выбор языка интерфейса",
        ruShort: "Русский",
        enShort: "English",
        ruAria: "Переключить интерфейс на русский",
        enAria: "Переключить интерфейс на английский",
      },
    },
  },
}
